import type { ContentObjectFormAfterSubmit } from '../../pages/AddContentObject/AddContentObjectContainer';

import { useCallback, useState } from 'react';

import AddContentObjectContainer from '../../pages/AddContentObject/AddContentObjectContainer';

interface CreateObjectContentModalProps {
  /**
   * Content object type name
   */
  contentTypeName: string;
  /**
   * Content object id
   */
  id?: string;
  /**
   * Edit modal test id
   */
  testId?: string;
  /**
   * Should the form have switches for enabling fields
   */
  isPatchable?: boolean;
}

const CreateObjectContentModal = ({
  contentTypeName,
  testId = '',
}: CreateObjectContentModalProps) => {
  const [objectData, setObjectData] = useState<Record<string, any>>();

  const afterSubmit = useCallback<ContentObjectFormAfterSubmit>(
    ({ success, contentObject }) => {
      if (success) setObjectData(contentObject);
    },
    [],
  );

  return (
    <AddContentObjectContainer
      contentTypeName={contentTypeName}
      id={objectData?.id}
      onSubmit={afterSubmit}
      testId={testId}
    />
  );
};

export default CreateObjectContentModal;
